import {
  Box,
  Text,
  Grid,
  Flex,
  Link,
  Image,
  Badge,
  Heading,
  VStack,
  Divider,
  SimpleGrid,
  Button,
  Skeleton,
  useColorModeValue,
} from '@chakra-ui/react'
import { ExternalLinkIcon } from '@chakra-ui/icons'
import { ImageSlider } from './ImageSlider'

export function ResultadoConsulta({ dados, isLoading }) {
  const bgBox = useColorModeValue('white', 'gray.700')
  const borderColor = useColorModeValue('gray.200', 'gray.600')

  if (isLoading) {
    return (
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} width="100%" maxWidth="1200px" mx="auto">
        {[1, 2].map((item) => (
          <Box key={item} boxShadow="md" borderRadius="lg" overflow="hidden" bg={bgBox} p={0}>
            <Skeleton height="200px" width="100%" mb={4} />
            <Box p={4}>
              <Skeleton height="20px" width="80%" mb={2} />
              <Skeleton height="20px" width="60%" mb={2} />
              <Skeleton height="20px" width="40%" mb={2} />
              <Skeleton height="20px" width="30%" />
            </Box>
          </Box>
        ))}
      </SimpleGrid>
    )
  }

  if (!dados || dados.length === 0) {
    return (
      <Box textAlign="center" p={10}>
        <Heading size="md" mb={4} color="gray.500">
          Nenhum resultado encontrado
        </Heading>
        <Text>Faça uma nova consulta com outros parâmetros.</Text>
      </Box>
    )
  }

  return (
    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} width="100%" maxWidth="1200px" mx="auto">
      {dados.map((item, index) => (
        <Box
          key={`${item.codigo_produto}-${item.cor}-${index}`}
          boxShadow="md"
          borderRadius="lg"
          overflow="hidden"
          bg={bgBox}
          borderWidth="1px"
          borderColor={borderColor}
        >
          <Box bg="#378BBF" color="white" py={3} px={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading size="md">Produto: {item.codigo_produto}</Heading>
              <Badge colorScheme="green" fontSize="0.8em" px={2} py={1} borderRadius="md">
                {item.cor}
              </Badge>
            </Flex>
          </Box>

          <Box p={4}>
            <VStack spacing={4} align="stretch">
              <Box>
                <Heading size="sm" mb={1} color="gray.600">
                  Descrição
                </Heading>
                <Text>{item.descricao_produto}</Text>
              </Box>

              <Divider />

              <Box>
                <Heading size="sm" mb={1} color="gray.600">
                  Informações do Fornecedor
                </Heading>
                <Grid templateColumns="repeat(2, 1fr)" gap={2}>
                  <Box>
                    <Text fontWeight="bold" fontSize="sm">
                      Nome:
                    </Text>
                    <Text>{item.fornecedor}</Text>
                  </Box>
                  <Box>
                    <Text fontWeight="bold" fontSize="sm">
                      Código:
                    </Text>
                    <Text>{item.codigo_fornecedor}</Text>
                  </Box>
                </Grid>
              </Box>

              <Divider />

              <Box>
                <Heading size="sm" mb={1} color="gray.600">
                  Imagens do Produto
                </Heading>
                <ImageSlider images={item.imagens_produto} alt={item.descricao_produto} />
              </Box>
            </VStack>
          </Box>

          <Box bg="gray.50" borderTop="1px" borderColor="gray.200" p={3}>
            <Link href={item.url_fornecedor} isExternal width="100%" _hover={{ textDecoration: 'none' }}>
              <Button rightIcon={<ExternalLinkIcon />} colorScheme="blue" variant="outline" size="sm" width="100%">
                Acessar URL do Fornecedor
              </Button>
            </Link>
          </Box>
        </Box>
      ))}
    </SimpleGrid>
  )
}
